import React from 'react';

export function VerticalTabs({ tabs, activeTab, onTabChange, children }) {
  return (
    <div className="flex gap-0 min-h-[400px]">
      {/* Left tab menu */}
      <div className="w-48 flex-shrink-0 border-r border-zinc-800 pr-2 space-y-1">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`w-full flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-left text-xs font-medium transition-all ${
              activeTab === tab.id
                ? 'bg-[#E5A100]/10 text-[#E5A100] border-l-2 border-[#E5A100]'
                : 'text-zinc-500 hover:text-zinc-200 hover:bg-zinc-800/50 border-l-2 border-transparent'
            }`}
          >
            {tab.icon && <tab.icon className="w-3.5 h-3.5 flex-shrink-0" strokeWidth={1.5} />}
            <span className="truncate">{tab.label}</span>
            {tab.count !== undefined && tab.count > 0 && (
              <span className={`ml-auto text-[10px] px-1.5 py-0.5 rounded-full ${
                activeTab === tab.id ? 'bg-[#E5A100]/20 text-[#E5A100]' : 'bg-zinc-800 text-zinc-500'
              }`}>
                {tab.count}
              </span>
            )}
            {tab.suffix && tab.suffix}
          </button>
        ))}
      </div>
      {/* Right content area */}
      <div className="flex-1 pl-4 min-w-0">
        {children}
      </div>
    </div>
  );
}
